import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=79d20718&scoped=true&"
import script from "./DefaultPage.vue?vue&type=script&lang=js&"
export * from "./DefaultPage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DefaultPage.vue?vue&type=style&index=1&id=79d20718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d20718",
  null
  
)

export default component.exports